import { CrmCheckInInteraction } from '@/types';

export enum CheckInTag {
  CLOSED = 'closed',
  MERCHANDIZING = 'merchandizing',
  PAYMENT = 'payment',
  PLACED_ORDER = 'placed_order',
  RETURN = 'return',
  VISITED = 'visited',
}

export const CHECK_IN_TAGS: CheckInTag[] = [
  CheckInTag.PAYMENT,
  CheckInTag.PLACED_ORDER,
  CheckInTag.RETURN,
  CheckInTag.MERCHANDIZING,
  CheckInTag.VISITED,
  CheckInTag.CLOSED,
];

export const CHECK_IN_TAG_INTERACTIONS: Record<
  CheckInTag,
  CrmCheckInInteraction
> = {
  [CheckInTag.CLOSED]: CrmCheckInInteraction.Closed,
  [CheckInTag.MERCHANDIZING]: CrmCheckInInteraction.Merchandising,
  [CheckInTag.PAYMENT]: CrmCheckInInteraction.Payment,
  [CheckInTag.PLACED_ORDER]: CrmCheckInInteraction.PlacedOrder,
  [CheckInTag.RETURN]: CrmCheckInInteraction.Return,
  [CheckInTag.VISITED]: CrmCheckInInteraction.Visited,
};
